<template>
  <div class="wg-row">
    <div class="wg-row" style="flex-wrap:nowrap;">
      <div class="display-flex" style="margin-left:auto;flex-direction:column;">
        <div class="time">{{ msg.ts | moment('HH:mm') }}</div>
      </div>
    </div>
    <div class="wg-row msg-row" v-html="$anm22.nl2br(msg.data.text)"></div>
  </div>
</template>

<script>
export default {
  props: {
    expBoard: Boolean,
    msg: Object,
    printUser: Boolean,
    msgUser: Object
  }
};
</script>

<style lang="scss" scoped>
.msg-row {
  flex-wrap: nowrap;
  align-items: center;
}
.font {
  font-family: sans-serif;
}
.time {
  // margin-top: 7%;
  font-size: 12px;
  margin-left: auto;
}
</style>
